import { getValueFromNestedObject } from "./operations/helper";

export function checkIfObjectContainsKeys(obj, keys) {
  const clone_obj = Object.assign({}, obj);
  if (typeof obj != 'object') throw ValidationError('`obj` must be an object');
  if (typeof keys === 'string') keys = keys?.split(',');

  if (!Array.isArray(keys))
    throw new ValidationError('`keys` must be an array');
  for (const key of keys)
    if (!clone_obj.hasOwnProperty(key))
      throw ValidationError(`Missing required key'${key}`);
}

export function ValidationError(msg, { cause = null, err_type = null } = {}) {
  const err = new Error();
  err.name = err_type || 'VALIDATION_ERROR';
  err.message = msg;
  if (cause) err.cause = cause;
  return err;
}

/**
 * 
 * @param {string[] | string} arrayed_param 
 * @param {any} store 
 * @returns {any[]}
 */
export function getParam(params, store) {
  console.log(store,params,'store')
  if(!params) return [];
  const arrayed_param = Array.isArray(params) ? params : [params];
  const result = [];
  for (let i = 0; i < arrayed_param.length; i++) {
    const param = arrayed_param[i];
    if (typeof param === 'string') {
      if (param.includes('@literal')) {
        const sanitized_param = param.replace('@literal', '').replace(':', '');
        result.push(sanitized_param);
      } else if (param.includes('@state')) {
        const sanitized_path = param.replace('@state', '').replace(':', '');
        const state_value = getValueFromNestedObject(store, sanitized_path);
        result.push(state_value);
      }
    }
  }
  return result;
}

export const isValidParams = (params) => {
    return params && Object.values(params).every(value => value !== null && value !== undefined);
}
